import React, { useRef } from 'react';
import { Grid, Box, Button, IconButton } from '@mui/material';

import ApexBarChartHorizontal from './Apex/ApexBarChartHorizontal';
import { CardAbsoluteChart, CardPercentageChart, CardPercentage2Chart, CardAverageChart, CardDistinctCountChart } from './Card/CardChart';
import { DatasetDruid, XLSXUtil } from '@datatox-bi/util';

import CardLabels from './Card/CardLabels';
import ApexPieChart from './Apex/ApexPieChart';
import ApexColumnChart from './Apex/ApexColumnChart';
import TitleContainer from './Title/TitleContainer';
import MapChart from './Map/MapChart';
import ApexLineChart from './Apex/ApexLineChart';
import TabelaDinamica from '../Pivottable/TabelaDinamica';
import ApexBarNegativeChart from './Apex/ApexBarNegativeChart';
import { SiMicrosoftexcel } from 'react-icons/si';

const ContainerGraph = ({ dataset, option, onResultObj, filtrosSecundarios }) => {
    const tableRef = useRef(null); //

    const datasetDruid = new DatasetDruid(dataset)
        .applyFilters(option.filters)
        .applyTransformations(option.transformations)
        .flatMap(option.preFlatMap || {})
        .addAttributes(option.addAttributes || [])
        .addAttribute(option.addAttribute || {})
        .selectDimensions(option.selectDimensions)
        .flatMap(option.flatMap || {})
        .applyFilters((option.postFilters || (() => {}))(filtrosSecundarios))
        .groupBy({ filterAgg: option.filterAgg, op: option.groupByOp, strAgg: option.groupByStrAgg })
        .groupByV2(option.groupByV2)
        .applyTransformations(option.postTransformations)
        .reduceDimensions(option.reduceDimensions)
        .topGroup({ limit: option.topGroupLimit, textOther: option.topGroupTextOther });

    console.log(datasetDruid, 'datasetDruid');

    return (
        <>
            {option.type === 'ApexBarChart' && (
                <Grid item sm={12} md={6 * (option.w || 1)} lg={6 * (option.w || 1)}>
                    <Box boxShadow={2} style={{ backgroundColor: 'white', borderRadius: '10px', padding: '15px' }}>
                        <Grid item xs={12}>
                            <TitleContainer title={option.title} description={option.description} />
                        </Grid>
                        <Grid item xs={12}>
                            <ApexBarChartHorizontal datasetDruid={datasetDruid.build()} title={option.title} uiConfig={option.uiConfig} />
                        </Grid>
                    </Box>
                </Grid>
            )}
            {option.type === 'ApexLineChart' && (
                <Grid item sm={12} md={6 * (option.w || 1)} lg={6 * (option.w || 1)}>
                    <Box boxShadow={2} style={{ backgroundColor: 'white', borderRadius: '10px', padding: '15px' }}>
                        <Grid item xs={12}>
                            <TitleContainer title={option.title} description={option.description} />
                        </Grid>
                        <Grid item xs={12}>
                            <ApexLineChart datasetDruid={datasetDruid.build()} title={option.title} uiConfig={option.uiConfig} />
                        </Grid>
                    </Box>
                </Grid>
            )}
            {option.type === 'ApexColumnChart' && (
                <Grid item sm={12} md={6 * (option.w || 1)} lg={6 * (option.w || 1)}>
                    <Box boxShadow={2} style={{ backgroundColor: 'white', borderRadius: '10px', padding: '15px' }}>
                        <Grid item xs={12}>
                            <TitleContainer title={option.title} description={option.description} />
                        </Grid>
                        <Grid item xs={12}>
                            <ApexColumnChart datasetDruid={datasetDruid.build()} title={option.title} uiConfig={option.uiConfig} />
                        </Grid>
                    </Box>
                </Grid>
            )}
            {option.type === 'ApexBarNegativeChart' && (
                <Grid item sm={12} md={6 * (option.w || 1)} lg={6 * (option.w || 1)}>
                    <Box boxShadow={2} style={{ backgroundColor: 'white', borderRadius: '10px', padding: '15px' }}>
                        <Grid item xs={12}>
                            <TitleContainer title={option.title} description={option.description} />
                        </Grid>
                        <Grid item xs={12}>
                            <ApexBarNegativeChart datasetDruid={datasetDruid.build()} title={option.title} uiConfig={option.uiConfig} />
                        </Grid>
                    </Box>
                </Grid>
            )}
            {option.type === 'ApexPieChart' && (
                <Grid item sm={12} md={6 * (option.w || 1)} lg={6 * (option.w || 1)}>
                    <Box boxShadow={2} style={{ backgroundColor: 'white', borderRadius: '10px', padding: '15px' }}>
                        <Grid item xs={12}>
                            <TitleContainer title={option.title} description={option.description} />
                        </Grid>
                        <Grid item xs={12} style={{ padding: '15px 0px 0px 0px' }}>
                            <ApexPieChart datasetDruid={datasetDruid.build()} uiConfig={option.uiConfig} />
                        </Grid>
                    </Box>
                </Grid>
            )}
            {option.type === 'CardAbsoluteChart' && (
                <Grid item sm={12} md={12} lg={2.4 * (option.w || 1)}>
                    <CardAbsoluteChart
                        datasetDruid={datasetDruid.build()}
                        title={option.title}
                        description={option.description}
                        having={option.having}
                        layout={option.layout}
                    />
                </Grid>
            )}
            {option.type === 'CardAverageChart' && (
                <Grid item sm={12} md={12} lg={2.4 * (option.w || 1)}>
                    <CardAverageChart datasetDruid={datasetDruid.build()} title={option.title} description={option.description} layout={option.layout} />
                </Grid>
            )}
            {option.type === 'CardDistinctCountChart' && (
                <Grid item sm={12} md={12} lg={2.4 * (option.w || 1)}>
                    <CardDistinctCountChart datasetDruid={datasetDruid.build()} title={option.title} description={option.description} layout={option.layout} />
                </Grid>
            )}
            {option.type === 'CardPercentageChart' && (
                <Grid item sm={12} md={12} lg={2.4 * (option.w || 1)}>
                    <CardPercentageChart
                        datasetDruid={datasetDruid.build()}
                        title={option.title}
                        description={option.description}
                        having={option.having}
                        enableAbsoluteValue={option.enableAbsoluteValue}
                        layout={option.layout}
                    />
                </Grid>
            )}
            {option.type === 'CardPercentage2Chart' && (
                <Grid item sm={12} md={6} lg={2.4 * (option.w || 1)}>
                    <CardPercentage2Chart
                        datasetDruid={datasetDruid.build()}
                        title={option.title}
                        description={option.description}
                        having={option.having}
                        layout={option.layout}
                    />
                </Grid>
            )}
            {option.type === 'CardLabels' && (
                <Grid item sm={12} md={12} lg={2 * (option.w || 6)}>
                    <CardLabels datasetDruid={datasetDruid.build()} labels={option.labels} />
                </Grid>
            )}
            {option.type === 'MapChart' && (
                <Grid item sm={12} md={6} lg={2 * (option.w || 3)}>
                    <Box boxShadow={2} style={{ backgroundColor: 'white', borderRadius: '10px', padding: '15px' }}>
                        <Grid item xs={12}>
                            <TitleContainer title={option.title} description={option.description} />
                        </Grid>
                        <Grid item xs={12}>
                            <MapChart datasetDruid={datasetDruid.build()} metaAtributos={option.metaAtributos} />
                        </Grid>
                    </Box>
                </Grid>
            )}
            {option.type === 'Pivottable' && (
                <Grid item sm={12} md={12} lg={2 * (option.w || 3)}>
                    <Box boxShadow={2} style={{ height: 'calc(100% - 30px)', backgroundColor: 'white', borderRadius: '10px', padding: '15px' }}>
                        <Grid container alignItems="center" spacing={2} sx={{ position: 'relative' }}>
                            <Grid item xs={12}>
                                <TitleContainer title={option.title} description={option.description} />
                            </Grid>
                            <IconButton
                                color="primary"
                                aria-label="download XLSX"
                                onClick={() => {
                                    if (tableRef.current) {
                                        XLSXUtil.exportarTabelaDinamicaParaXLSX(tableRef.current, option.title);
                                    }
                                }}
                                sx={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '10px'
                                }}
                            >
                                <SiMicrosoftexcel />
                            </IconButton>
                        </Grid>
                        <Grid item xs={12} sx={{ height: option.h || '555px', alignItems: 'center', overflowY: 'auto' }}>
                            <Box ref={tableRef} sx={{ width: '100%', height: '100%' }}>
                                <TabelaDinamica
                                    rows={option.rows}
                                    cols={option.cols}
                                    rowOrder={option.rowOrder}
                                    dataset={datasetDruid.build()}
                                    metaAtributos={option.metaAtributos}
                                    headers={option.headers}
                                    aggregatorList={option.aggregatorList}
                                    vals={option.vals}
                                    enablePercentage={option.enablePercentage}
                                    aggregatorName={option.aggregatorName}
                                />
                            </Box>
                        </Grid>
                        {option.legend && (
                            <Grid item xs={12} sx={{ mb: 1 }}>
                                <Box
                                    sx={{
                                        backgroundColor: '#f5f5f5',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        fontSize: '0.875rem',
                                        color: '#666',
                                    }}
                                >
                                    {option.legend}
                                </Box>
                            </Grid>
                        )}
                    </Box>
                </Grid>
            )}
        </>
    );
};

const DashboardContainer = ({ dataset, options, onResultObj = () => {}, filtrosSecundarios }) => {
    const charts = React.useMemo(
        () =>
            options.map((option, i) => (
                <ContainerGraph dataset={dataset} option={option} key={i} onResultObj={onResultObj} filtrosSecundarios={filtrosSecundarios} />
            )),
        [options]
    );

    return (
        <Grid container spacing={1}>
            {charts}
        </Grid>
    );
};

const DashboardInnerContainer = ({ dataset, options, onResultObj = () => {}, filtrosSecundarios }) => {
    const charts = React.useMemo(
        () =>
            options.map((option, i) => (
                <ContainerGraph dataset={dataset} option={option} key={i} onResultObj={onResultObj} filtrosSecundarios={filtrosSecundarios} />
            )),
        [options]
    );

    return <>{charts}</>;
};

export { DashboardContainer, DashboardInnerContainer };
